import { Account, AccountInvite } from './accountType';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class AccountApi {

  //http://localhost:3000/api/v1/companies/accounts/4
  static async getCompanyNameByAccountId(account_id: string) {
    try {
      const response = await fetch(`${API_BASE_URL}/companies/accounts/${account_id}`, {
        method: 'GET',
        credentials: 'include',  // If you need to send cookies
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const responseBody = await response.json();

      if (response.status === 200) {
        //console.log('d---d:  ', responseBody.data)

        //const company_name = responseBody.body.attributes.company_name;
        return responseBody;

      }
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      }
      else {
        throw new Error(`${responseBody.error}, status: ${response.status}`);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to get company by account: ${error.message}`);
      } else {
        throw new Error('Failed to get company by account: An unknown error occurred.');
      }
    }
  }



  static async getAccountInvite(token: string) {
    try {
      const response = await fetch(`${API_BASE_URL}/accounts/get_account_invite?token=${token}`, {
        method: 'GET',
        //credentials: 'include',  // If you need to send cookies
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const responseBody = await response.json();

      if (response.status === 200) {
        const accountInvite: AccountInvite = responseBody;  // or responseBody if that's your variable name
        //console.log('====account accountInvite=====', accountInvite)
        return accountInvite;
      }
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      }
      else {
        throw new Error(`${responseBody.error}, status: ${response.status}`);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to get company by account: ${error.message}`);
      } else {
        throw new Error('Failed to get company by account: An unknown error occurred.');
      }
    }
  }




  static async sendAccountInvite(accountId: string, companyCode: string, sendMethod: string, recipientEmail: string, recipientPhone: string): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/accounts/send_account_invite`, {
        method: 'POST',
        credentials: 'include',  // If you need to send cookies
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sender_account_id: accountId,
          sender_company_code: companyCode,
          send_method: sendMethod,
          recipient_email: recipientEmail,
          recipient_phone: recipientPhone// Ensure consistent naming
        }),
      });

      const responseBody = await response.json();

      if (response.status < 300) {
        return responseBody;
      }
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      }
      else {
        throw new Error(`Account invitation failed: status ${response.status} - ${responseBody.message} `);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to create account: ${error.message}`);
      } else {
        throw new Error('Failed account invitation: An unknown error occurred.');
      }
    }
  }



  static async create_google_account(token: string, companyCode: string) {

    //console.log('=====account===:', account);
    try {
      const response = await fetch(`${API_BASE_URL}/accounts/create_google_account`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
          company_code: companyCode, // Ensure consistent naming
        }),
      });

      const responseBody = await response.json();

      if (response.status < 300) {
        //console.log('account api---', responseBody);
        return responseBody;
      }
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      }
      else {
        if (responseBody.error.includes('duplicate')) {
          // This checks if the word "duplicate" appears in the error message
          //throw new Error('Duplicated data entries' || `Error: Status ${response.status}`);
          throw new Error(`Duplicated data entries status ${response.status}`);
        }
        else {
          throw new Error(response.statusText);
        }
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to create account: ${error.message}`);
      } else {
        throw new Error('Failed to create account: An unknown error occurred.');
      }
    }
  }

  static async getAccount(accountId: string) {
    try {

      const response = await fetch(`${API_BASE_URL}/accounts/${accountId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies in the request
      });

      //console.log('=====response======', response)
      const responseBody = await response.json();

      if (response.status === 200) {
        const account: Account = responseBody.data.attributes;
        return account;
      }
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      }
      else {
        throw new Error(`${responseBody.error}, status: ${response.status}`);
      }
    }
    catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to get account: ${error.message}`);
      } else {
        throw new Error('Failed to get account: An unknown error occurred.');
      }
    }
  }

  static async update(AccountId: string, account: Account) {
    try {

      const response = await fetch(`${API_BASE_URL}/accounts/${AccountId}`, {
        method: 'PATCH',
        credentials: 'include',  // If you need to send cookies
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ account: account }),
      });
      const responseBody = await response.json();

      if (response.status === 200) {
        //console.log('d---d:  ', responseBody.data)
        //return company;
      }
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      }
      else {

        //throw new Error(response.statusText || `Error: Status ${response.status}`);
        throw new Error(`${responseBody.error}, status: ${response.status}`);
      }

    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to update account: ${error.message}`);
      } else {
        throw new Error('Failed to update account: An unknown error occurred.');
      }
    }


  }

  static async create(account: Account) {

    //console.log('=====account===:', account);
    try {
      const response = await fetch(`${API_BASE_URL}/accounts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ account: account }),
      });

      const responseBody = await response.json();


      if (response.status < 300) {
        //console.log('account api---', responseBody);
        return responseBody;
      }
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      }
      else {
        if (responseBody.error.includes('duplicate')) {
          // This checks if the word "duplicate" appears in the error message
          //throw new Error('Duplicated data entries' || `Error: Status ${response.status}`);
          throw new Error(`Duplicated data entries status ${response.status}`);
        }
        else {
          throw new Error(response.statusText);
        }
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to create account: ${error.message}`);
      } else {
        throw new Error('Failed to create account: An unknown error occurred.');
      }
    }
  }


  static async changePassword(currentPassword: string, newPassword: string, confirmPassword: string) {
    try {
      // Validate that the new password and confirmation match
      if (newPassword !== confirmPassword) {
        throw new Error('New password and confirmation do not match.');
      }

      // Send the request to the backend
      const response = await fetch(`${API_BASE_URL}/accounts/change_password`, {
        method: 'POST',
        credentials: 'include',  // If you need to send cookies
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      });

      // Parse the response
      const responseBody = await response.json();

      // Handle success
      if (response.status === 200) {
        return responseBody;
      }
      else if (response.status === 401) {
        throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
      }
      else {
        // Handle errors
        throw new Error(responseBody.error || response.statusText);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to change password: ${error.message}`);
      } else {
        throw new Error('Failed to change password: An unknown error occurred.');
      }
    }
  }

}


export default AccountApi;